@if (isVisible()) {
  <div class="call-widget-overlay">
    <div
      class="call-widget"
      [class.call-widget--connected]="isLive()"
      cdkDrag
      cdkDragBoundary=".call-widget-overlay"
    >
      <div class="call-widget__info">
        <button
          type="button"
          class="call-widget__grip"
          cdkDragHandle
          aria-label="Move call widget"
        >
          <i class="fa-regular fa-grip"></i>
        </button>

        <div class="call-widget__details">
          @if (isCaseLinkVisible()) {
            <button
              type="button"
              class="call-widget__name call-widget__name--linkable"
              (click)="onNavigateToCase()"
            >
              {{ contactName() }}
            </button>
          } @else {
            <span class="call-widget__name">{{ contactName() }}</span>
          }

          @if (isEnding()) {
            <span class="call-widget__status">{{ endLabel() }}</span>
          } @else if (isLive()) {
            <div class="call-widget__live-group">
              <span class="call-widget__status call-widget__status--live">
                <span class="call-widget__live-dot" aria-hidden="true"></span>
              </span>
              <span class="call-widget__timer">{{ elapsedLabel() }}</span>
            </div>
          } @else if (isRingingCall()) {
            <span class="call-widget__status">Calling…</span>
          } @else {
            <span class="call-widget__status">Starting call…</span>
          }
        </div>
      </div>

      <div class="call-widget__actions">
        <button
          type="button"
          class="call-widget__action call-widget__action--neutral"
          [class.call-widget__action--active]="isMuted()"
          [disabled]="isEnding()"
          [attr.aria-pressed]="isMuted()"
          [attr.aria-label]="
            isMuted() ? 'Unmute microphone' : 'Mute microphone'
          "
          (click)="onToggleMute()"
        >
          <i
            class="fa-regular"
            [class.fa-microphone]="!isMuted()"
            [class.fa-microphone-slash]="isMuted()"
          ></i>
        </button>

        <button
          type="button"
          class="call-widget__action call-widget__action--hangup"
          [disabled]="isEnding()"
          aria-label="End call"
          (click)="onHangUp()"
        >
          <i class="fa-regular fa-phone-hangup"></i>
        </button>
      </div>
    </div>
  </div>
}
